import Vue from 'vue'

const echarts = require('echarts')
Vue.prototype.$echarts = echarts
